import * as React from 'react';

import { DemandTrapBanner } from '../../components/DemandTrapBanner';
import { useShowBanner } from './useShowBanner';

/**
 * Контейнер, где формируется баннер для add-form.jade
 */
export const BannerContainer: React.FC<React.ReactNode> = () => {
  const { showDemandTrapBanner, category } = useShowBanner();

  if (showDemandTrapBanner) {
    return <DemandTrapBanner dealType={category.dealType} />;
  } else {
    return null;
  }
};
